import { render, staticRenderFns } from "./SportsVolleyball.vue?vue&type=template&id=0bfa762a&"
import script from "./SportsVolleyball.vue?vue&type=script&lang=js&"
export * from "./SportsVolleyball.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports